module.exports = __webpack_public_path__ + "static/media/servicePhotoIcon.07ea79a1.svg";